import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import store from "redux/store";
import {
  GET_LOGOUT_FAILURE,
  GET_LOGOUT_REQUESTED,
  GET_LOGOUT_SUCCESS,
} from "resources/actionTypes";
import { logoutApi } from "services/LogoutService";

function* fetchLogout(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userLogout = yield call(logoutApi, payload.userLogout);
  if (userLogout.success) {
    yield put({ type: GET_LOGOUT_SUCCESS, userLogout: userLogout });
    store.dispatch(onLoaderTrigger(false));
		localStorage.clear();
		window.location.replace("/login");
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_LOGOUT_FAILURE, message: userLogout.message });
    toast.error(userLogout.message || "Logout Failed");  
  }
}
function* logoutSaga() {
  yield takeEvery(GET_LOGOUT_REQUESTED, fetchLogout);
}

export default logoutSaga;
